const defaultCompany = {
  name: "",
  city: "",
  address: "",
  phone: "",
  email: "",
  lib: "",
  pib: "",
  description: "",
  state: 1,
  checkReport: 0,
  no_time_limit: 0,
  shift_one: 1,
  shift_two: 0,
  shift_three: 0,
  shift_four: 0,
  contract: 1,
  lat: "",
  long: "",
  type: "small",
  change_shift_label: false,
  everyday_offer: false,
  is_translate_shift: false,
  contact_person: ""
};

const defaultCompanySettings = {
  current_shift_meal: false,
  days: {
    monday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    tuesday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    wednesday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    thursday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    friday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    saturday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    sunday: {
      time: {
        time_hour: "",
        time_minut: "",
      },
      day_before_limit: "",
      day_after_limit: "",
    },
    day: {
      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
      sunday: "",
    },
  },
  order_from_one_shift_to_another_can: true,
  global_restaurant_time_settings: false,
  confirm_delivery: false,
  can_see_ordered: false,
  order_from_one_shift_to_another: true,
  can_see_report: false,
  all_cooperation: false,
  no_time_limit: false,
  show_price: false,
  worker: false,
}

const deliveryCompany = {
  name: "",
  delivery: [],
  restaurant_id: "",
  active_restoran: [],
  active_company: [],
  paying_type: [],
  paying: [],
  internal: [],
  city: "",
  address: "",
  phone: "",
  email: "",
  lib: "",
  pib: "",
  description: "",
  state: 1,
  checkReport: 0,
  shift_one: 1,
  shift_two: 2,
  shift_three: 3,
  contract: 1,
  lat: "",
  long: "",
  type: "small",
}

const defaultCredit = {
  naziv: "",
  rabat: "",
  percent: "",
  date_from: null,
  date_to: null,
  active: "",
  date: "",
};

export { defaultCompany, defaultCompanySettings, deliveryCompany, defaultCredit };
